<template>
  <div class="user">
    <div class="info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        href="#"
      >
        <span v-if="user.current">
          {{ user.current.nombres | capitalize }}
          <strong class="caret"></strong>
        </span>
      </a>
      <div class="clearfix"></div>
      <div v-if="!menus.loading">
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <slot>
              <div v-if="menus.menus.profile">
                <template v-for="menu in menus.menus.profile.items">
                  <li>
                    <a class="profile-dropdown" @click="logout">
                      <span class="sidebar-mini">{{ menu.color }}</span>
                      <span class="sidebar-normal">{{ menu.descripcion }}</span>
                    </a>
                  </li>
                </template>
              </div>
            </slot>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import { mapState } from "vuex";
import auth from "@/service/auth";

export default {
  components: {
    [CollapseTransition.name]: CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      logo: "/img/logo.jpg",
      isClosed: true,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      menus: (state) => state.menus,
    }),
  },
  methods: {
    toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    logout() {
      auth.logout();
    },
  },
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}

.info {
  margin: 5px 15px 0px 10px;
}
</style>
